module.exports = __webpack_public_path__ + "img/logo3.00a76d2b.png";